var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiConversationTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5787 2.85712H17.0022L11.7077 8.9084L17.9362 17.1428H13.0593L9.23953 12.1487L4.86883 17.1428H2.44392L8.10693 10.6703L2.13184 2.85712H7.13257L10.5853 7.42195L14.5787 2.85712ZM13.7282 15.6923H15.071L6.4029 4.23148H4.96187L13.7282 15.6923Z",
    fill: "#616B84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiConversationTwitter);
export default __webpack_public_path__ + "static/media/hi-conversation-twitter.be63d3910375ccc06dd3501bce920839.svg";
export { ForwardRef as ReactComponent };